import { render, staticRenderFns } from "./editor-image.vue?vue&type=template&id=fa6adf12&scoped=true&"
import script from "./editor-image.vue?vue&type=script&lang=js&"
export * from "./editor-image.vue?vue&type=script&lang=js&"
import style0 from "./editor-image.vue?vue&type=style&index=0&id=fa6adf12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6adf12",
  null
  
)

export default component.exports